<template>
  <div class="templateManagement">
    <div class="btnBox">
      <div>
        <el-button
          v-if="isKindergarten"
          size="mini"
          :style="{ background: '#5474e6' }"
          type="primary"
          @click="addDialogVisible = true"
          >创建</el-button
        >
      </div>
      <div class="flex-items">
        <el-input v-model="Name" placeholder="请输入搜索内容"></el-input>
        <el-button
          type="primary"
          style="margin-left: 20px"
          @click="GetTenantTempByPage"
          >查询</el-button
        >
        <!-- <el-button size="mini" type="primary">一键开启</el-button> -->
      </div>
    </div>

    <div v-if="userInfo.UserIdentity.indexOf('2') != -1">
      <!-- 学年列表 -->
      <!-- @click="changeYear(item)" -->
      <!--  -->
      <div class="gradeList" v-if="btn_study_year.length > 1">
        <div
          :class="['grade', item.Id == btn_study_year_id ? 'gradeActive' : '']"
          :style="{
            'z-index': classList.length + 3 - index,
            transform: 'translateX(' + index * 24 * -1 + 'px)',
          }"
          v-for="(item, index) in btn_study_year"
          :key="index"
          @click="yearChangeList(item)"
        >
          {{ item.Name }}
        </div>
      </div>
      <!-- 学期列表 -->
      <div class="gradeList" v-if="btn_study_cycle.length > 1">
        <div
          :class="['grade', item.Id == btn_study_cycle_id ? 'gradeActive' : '']"
          :style="{
            'z-index': classList.length + 3 - index,
            transform: 'translateX(' + index * 24 * -1 + 'px)',
          }"
          @click="CycleChenge(item)"
          v-for="(item, index) in btn_study_cycle"
          :key="index"
        >
          {{ item.Name }}
        </div>
      </div>
      <!-- 班级列表 -->
      <div class="gradeList">
        <div
          :class="['grade', item.Id == classList_id ? 'gradeActive' : '']"
          :style="{
            'z-index': classList.length + 3 - index,
            transform: 'translateX(' + index * 24 * -1 + 'px)',
          }"
          @click="ClassChange(item)"
          v-for="(item, index) in classList"
          :key="index"
        >
          {{ item.Name }}
        </div>
      </div>
    </div>

    <div class="row" v-for="(item, index) in list" :key="index">
      <div class="RowTop">
        <div class="RowTopName">成长档案</div>
        <div class="classInfo">
          <span>{{ item.Range }}</span>
          <span>{{ item.StudyYearName }}</span>
          <span>{{ item.CycleName }}</span>
        </div>
        <div class="time">{{ item.CreateTime }}</div>
      </div>
      <div class="rowName">{{ item.Title }}</div>
      <div class="rowBottom">
        <div class="status">
          <!-- 开启关闭名称 1开启 0关闭 2是初始化也是关闭 （0/2都可以开启 1可以关闭） -->
          <img v-if="item.Status == 1" src="@/assets/check2.png" alt="" />
          <img v-else src="@/assets/close2.png" alt="" />
          <span>{{ item.Status == 1 ? "已开启" : "已关闭" }} </span>
        </div>
        <div class="buttonList" v-if="!(item == 0 && userInfo.ParentId == 12)">
          <div class="edit btn" @click="editFn(item)" v-if="item.Status != 1">
            <img src="@/assets/edit.png" alt="" /><span style="color: #4083fe"
              >编辑</span
            >
          </div>
          <!-- v-if="item.Status != 1" -->
          <!--  -->
          <div
            class="deploy btn"
            @click="deployFn(item)"
            v-if="item.Status != 1"
          >
            <img src="@/assets/deploy.png" alt="" /><span style="color: #4083fe"
              >模板配置</span
            >
          </div>
          <div
            class="close btn"
            v-if="item.Status == 1"
            @click="openOrClose(item)"
          >
            <img src="@/assets/close2.png" alt="" /><span style="color: #333333"
              >关闭</span
            >
          </div>
          <div class="open btn" v-else @click="openOrClose(item)">
            <img src="@/assets/check3.png" alt="" /><span style="color: #4083fe"
              >开启</span
            >
          </div>
          <div
            class="edit btn"
            @click="ClearGrowthResultInfo(item)"
            v-if="userInfo.UserIdentity.indexOf('2') != -1"
          >
            <img src="@/assets/close2.png" alt="" /><span>清空模块数据</span>
          </div>
          <div
            class="detele btn"
            @click="deteleFn(item)"
            v-if="item.Status != 1"
          >
            <img src="@/assets/delete2.png" alt="" /><span
              style="color: #e14747"
              >删除</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pagesizeChange"
        :page-size="10"
        :total="dataCount"
      >
      </el-pagination>
    </div> -->
    <img class="noData" v-if="!isHasData" src="@/assets/noData2.png" alt="" />
    <!-- 新增 -->
    <el-dialog title="新增" :visible.sync="addDialogVisible" width="30%">
      <!--  -->
      <div>
        <div class="inputBox">
          <div class="label">周期类型：</div>
          <el-select
            v-model="typeValue"
            @change="typeChange"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">范围：</div>
          <el-select
            v-model="addFrom.range"
            @change="scopeChange"
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in scopeList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">学年：</div>
          <el-select v-model="addFrom.Year" size="mini" placeholder="请选择">
            <el-option
              v-for="item in AcademicOptions"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputBox" v-if="typeValue == 1">
          <div class="label">学期：</div>
          <el-select v-model="addFrom.cycleId" size="mini" placeholder="请选择">
            <el-option
              v-for="item in CycleList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="inputBox">
          <div class="label">名称：</div>
          <el-input
            size="mini"
            style="width: 193px"
            v-model="addFrom.title"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFn">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="30%">
      <div>
        <div class="inputBox">
          <div class="label">名称：</div>
          <el-input
            size="mini"
            style="width: 193px"
            v-model="editFrom.Title"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editFnAffirm">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 删除模块 -->
    <el-dialog title="删除模块" :visible.sync="dialogVisibleDelete" width="30%">
      <div>
        <el-alert
          title="提示：该功能是清空单个模块全部数据，以便于使用批量操作数据功能，如无此需求请勿点击进入"
          type="error"
          :closable="false"
        >
        </el-alert>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDelete = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="countdown > 0"
          @click="startCountdown"
          >{{ countdownText }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetTenantTempRange,
  getAcademicSelect,
  getCycleSelect,
  CreateTenantTempInfo,
  GetTenantTempByPage,
  UpdateTenantTempOneInfo,
  GetTenantTempOneInfo,
  OpenCloseTenantTempOneInfo,
  DeleteTenantTempOneInfo,
  GetCycleSelectListByScope,
  GetOpenCycleInfoSelectResult,
  GetClassSelect,
} from "@/api/api";
export default {
  data() {
    return {
      userInfo: {},
      list: [],
      btn_study_year: [], //学界列表
      btn_study_year_id: "",
      classList: [], //班级列表\
      classList_id: "",
      btn_study_cycle: [], // 周期列表
      btn_study_cycle_id: "",
      GradeId: "", //年级id
      addDialogVisible: false,
      editDialogVisible: false,
      typeValue: "",
      scopeList: [], //范围列表
      typeList: [
        {
          label: "学期",
          value: 1,
        },
        {
          label: "学年",
          value: 0,
        },
      ],
      AcademicOptions: [], //学年列表
      CycleList: [], //周期列表
      PageIndex: 1,
      dataCount: 0,
      isHasData: true,
      addFrom: {
        //新增参数
        // type: 1,
        code: "",
        range: "", //范围
        studyYearId: "", //学年id
        cycleId: "", //周期id
        title: "",
        Year: "",
      },
      editFrom: {
        Code: "",
        CycleId: "",
        Id: "",
        Range: "",
        Status: "",
        StudyYearId: "",
        Title: "",
      },
      isKindergarten: false, //是否是园长
      isXhr: false,
      Name: "",
      dialogVisibleDelete: false,
      countdown: 0, // 倒计时剩余时间
      timer: null, // 计时器
      clickInfo: {},
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    let UserIdentityArr = this.userInfo.UserIdentity.split(";");
    let isKindergarten = UserIdentityArr.find((item) => {
      return item == 1 || item == 0;
    });
    if (isKindergarten) {
      this.isKindergarten = true;
    } else {
      this.isKindergarten = false;
    }
    if (this.isKindergarten) {
      this.GetTenantTempByPage();
    } else {
      this.getAcademicSelectList();
    }
    this.getFullYear();
  },
  computed: {
    countdownText() {
      if (this.countdown > 0) {
        return `${this.countdown}秒后可用`;
      } else {
        return "确 定";
      }
    },
  },
  methods: {
    async startCountdown() {
      let info = escape(
        JSON.stringify({
          id: this.clickInfo.Id,
          GradeName: this.clickInfo.Range,
          StudyYearName: this.clickInfo.StudyYearName,
          CycleName: this.clickInfo.CycleName,
          CycleId: this.clickInfo.CycleId,
          StudyYearId: this.clickInfo.StudyYearId,
          Status: this.clickInfo.Status,
          GradeId: this.clickInfo.GradeId,
          GradeNameS: this.clickInfo.GradeName,
          ClassName: this.clickInfo.Range,
          ClassId: this.clickInfo.ClassId,
          Clear: 1,
        })
      );
      this.$router.push({
        path: "/templateConfiguration",
        query: {
          info: info,
        },
      });
    },
    ClearGrowthResultInfo(item) {
      this.dialogVisibleDelete = true;
      this.clickInfo = item;
      this.countdown = 3; // 设置倒计时时间为15秒
      this.timer = setInterval(() => {
        this.countdown--; // 更新剩余时间
        if (this.countdown <= 0) {
          clearInterval(this.timer); // 停止计时器
          this.timer = null;
        }
      }, 1000);
    },
    yearChangeList(item) {
      this.btn_study_year_id = item.Id;
      this.getCycleSelect();
    },
    ClassChange(item) {
      this.classList_id = item.Id;
      this.GetTenantTempByPage();
    },
    //
    CycleChenge(item) {
      this.btn_study_cycle_id = item.Id;
      this.GradeId = item.GradeId;
      this.getClassList(item.Id, item.GradeName);
    },
    //
    changeYear(item) {
      this.btn_study_year_id = item.Id;
      this.getCycleSelect(item.Id);
    },
    // 获取学届
    async getAcademicSelectList() {
      let res = await getAcademicSelect({
        Uid: this.userInfo.uID,
        SchoolId: this.userInfo.SchoolId,
        Type: this.isKindergarten ? 3 : 2, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (res.data.success) {
        this.btn_study_year = res.data.response;
        this.btn_study_year_id = this.btn_study_year[0].Id;
        this.getCycleSelect();
      } else {
        this.btn_study_year = [];
      }
    },
    async GetOpenCycleInfoSelectResult() {
      let xhr = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.yearList[this.yearIndex].Id,
      });
      if (xhr.data.success) {
        this.CycleList = xhr.data.response;
        this.CycleIndex = 0;
        if (this.CycleList.length) {
          await this.GetClassSelect();
          await this.AdminGetAllCategory();
        }
      } else {
        this.CycleList = [];
        this.CategoryList = [];
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },
    // 获取学期列表
    async getCycleSelect() {
      let xhr = await GetOpenCycleInfoSelectResult({
        SchoolId: this.userInfo.SchoolId,
        StudyYearsId: this.btn_study_year_id,
      });
      if (xhr.data.success) {
        this.btn_study_cycle = xhr.data.response;
        this.btn_study_cycle_id = xhr.data.response[0].Id;
        this.GradeId = xhr.data.response[0].GradeId;
        if (this.btn_study_cycle.length) {
          this.getClassList();
        }
      } else {
        this.btn_study_cycle = [];

        this.$message.warning(xhr.data.msg);
      }
    },
    // 获取班级列表
    async getClassList() {
      let xhr = await GetClassSelect({
        StudyYearId: this.btn_study_year_id,
        SchoolId: this.userInfo.SchoolId,
        GradeId: this.GradeId, //EvaluationType==2 1学生、2教师、3校长、4家长
      });
      if (xhr.data.success) {
        this.classList = xhr.data.response;
        this.classList_id = xhr.data.response[0].Id;
        this.GetTenantTempByPage();
      } else {
        this.classList = [];
        this.$message.warning(xhr.data.msg);
      }
    },

    // 删除
    deteleFn(item) {
      const h = this.$createElement;
      let that = this;
      this.$msgbox({
        title: "操作提示",
        message: h("p", null, [
          h("span", null, "是否确认"),
          h("i", { style: "color: red" }, "删除？"),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            let xhr = await DeleteTenantTempOneInfo({
              id: item.Id,
            });
            if (xhr.data.success) {
              that.$message.success("删除成功");
              that.GetTenantTempByPage();
            } else {
              that.$message.error(xhr.data.msg);
            }
          }
          done();
        },
      });
    },
    //   开启或关闭成长足迹
    async openOrClose(item) {
      // if (item.Status == 0 && this.userInfo.ParentId == 12) {
      //   this.$message.warning("无法再次开启");
      //   return;
      // }
      const h = this.$createElement;
      let that = this;
      this.$msgbox({
        title: "操作提示",
        message: h("p", null, [
          h("span", null, "是否确认"),
          h(
            "i",
            { style: "color: red" },
            this.userInfo.ParentId == 12
              ? item.Status == 1
                ? "关闭？关闭后该档案所有数据不可更改，请谨慎操作"
                : "开启？"
              : item.Status == 1
              ? "关闭？"
              : "开启？"
          ),
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            let xhr = await OpenCloseTenantTempOneInfo({
              id: item.Id,
              status: item.Status == 1 ? 0 : 1,
            });
            if (xhr.data.success) {
              that.$message.success("操作成功");
              that.GetTenantTempByPage();
            } else {
              that.$message.error(xhr.data.msg);
            }
          }
          done();
        },
      });

      //
    },
    //  获取范围
    async GetThemeRange() {
      let xhr = await GetTenantTempRange({
        Id: this.typeValue,
      });
      if (xhr.data.success) {
        this.scopeList = xhr.data.response;
        // this.addFrom.range = xhr.data.response[0].Id;
      } else {
        this.scopeList = [];
        // 你选择学年的时候      CycleId=0  StudyYearId是学年
        // 你选择学期的时候      CycleId>0  StudyYearId是学届Id
      }
    },
    typeChange() {
      this.GetThemeRange();
    },
    async scopeChange(e) {
      //console.log(e, this.scopeList);
      let find = this.scopeList.find((item) => {
        return item.Id == e;
      });
      let xhr = await GetCycleSelectListByScope({
        Name: find.Name,
      });
      this.CycleList = xhr.data.response;
    },
    // 获取学年
    getFullYear() {
      let nowDate = new Date();
      let year = nowDate.getFullYear() + 3;
      for (let index = 6; index >= 0; index--) {
        this.AcademicOptions.push({
          Id: year - index,
          Name: year - index,
        });
      }
    },
    // 获取学年
    dropdownAcademicSelectSearch(show) {
      getAcademicSelect().then((res) => {
        if (res.data.success) {
          this.AcademicOptions = res.data.response;
        }
      });
    },

    async GetTenantTempByPage() {
      let params = {
        PageIndex: this.PageIndex,
        PageSize: 10000,
        Name: this.Name,
      };
      if (!this.isKindergarten) {
        params.StudyYearId = this.btn_study_year_id;
        params.GradeId = this.GradeId;
        params.ClassId = this.classList_id;
        params.CycleId = this.btn_study_cycle_id;
      }

      let xhr = await GetTenantTempByPage(params);
      if (xhr.data.success) {
        this.list = xhr.data.response.data;
        this.dataCount = xhr.data.response.dataCount;
      } else {
        this.list = [];
      }
      if (this.list.length != 0) {
        this.isHasData = true;
      } else {
        this.isHasData = false;
      }
    },
    async addFn() {
      if (this.addFrom.title == "") {
        this.$message.warning("请填写名称");
        return;
      }
      if (this.addFrom.range == "") {
        this.$message.warning("请选择范围");
        return;
      }
      if (this.addFrom.Year == "") {
        this.$message.warning("请选择学年");
        return;
      }
      let find = this.CycleList.find((item) => {
        return item.Id == this.addFrom.cycleId;
      });

      if (find && this.typeValue == 1) {
        this.addFrom.studyYearId = find.StudyYearId;
      } else {
        this.addFrom.studyYearId = "0";
        this.addFrom.cycleId = "0";
      }
      //console.log(this.addFrom.studyYearId, find, this.addFrom);
      if (this.isXhr) {
        return;
      }
      this.isXhr = true;
      this.addDialogVisible = false;
      let xhr = await CreateTenantTempInfo(this.addFrom);
      this.isXhr = false;
      if (xhr.data.success) {
        this.addFrom.code = "";
        this.addFrom.range = "";
        this.addFrom.studyYearId = "";
        this.addFrom.Year = "";
        this.addFrom.cycleId = "";
        this.addFrom.title = "";
        this.CycleList = [];
        this.scopeList = [];
        // this.AcademicOptions = [];
        this.typeValue = "";
        this.$message.success("添加成功");
        this.GetTenantTempByPage();
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    pagesizeChange(e) {
      this.PageIndex = e;
      this.GetTenantTempByPage();
    },
    async editFn(item) {
      let xhr = await GetTenantTempOneInfo({
        id: item.Id,
      });
      if (xhr.data.success) {
        this.editDialogVisible = true;
        this.editFrom = xhr.data.response;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    async editFnAffirm() {
      if (this.editFrom.Title == "") {
        this.$message.warning("请填写名称");
        return;
      }
      this.editDialogVisible = false;
      let xhr = await UpdateTenantTempOneInfo(this.editFrom);
      if (xhr.data.success) {
        this.$message.success("修改成功");
        this.GetTenantTempByPage();
      } else {
        this.$message.error(xhr.data.msg);
      }
    },
    deployFn(item) {
      let info = escape(
        JSON.stringify({
          id: item.Id,
          GradeName: item.Range,
          StudyYearName: item.StudyYearName,
          CycleName: item.CycleName,
          CycleId: item.CycleId,
          StudyYearId: item.StudyYearId,
          Status: item.Status,
          GradeId: item.GradeId,
          GradeNameS: item.GradeName,
          ClassName: item.Range,
          ClassId: item.ClassId,
        })
      );
      this.$router.push({
        path: "/templateConfiguration",
        query: {
          info: info,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.gradeList {
  height: 30px;
  margin-bottom: 10px;
  .grade {
    position: relative;
    display: inline-block;
    min-width: 83px;
    height: 30px;
    border: 1px solid #cdcdcd;
    background: #e5ebff;
    border-radius: 15px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding-right: 14px;
    padding-left: 34px;
    box-sizing: border-box;
    line-height: 30px;
    color: #333333;
    cursor: pointer;
  }
  .grade:nth-child(1) {
    padding-left: 14px;
  }
  .gradeActive {
    color: #ffffff;
    background: #5474e6;
    border: 1px solid #5474e6;
  }
}
/deep/.el-dialog {
  border-radius: 10px;
  overflow: hidden;
}
/deep/.el-dialog__header {
  background: #f2f5ff;
}
.inputBox {
  display: flex;
  margin-bottom: 28px;
  .label {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    width: 90px;
  }
}
.templateManagement {
  padding: 20px;
  padding-top: 0;
  box-sizing: border-box;
  .noData {
    display: block;
    width: 230px;
    height: auto;
    margin: 0 auto;
    margin-top: 200px;
  }
  .row {
    width: 100%;
    height: 131px;
    background: rgba(132, 159, 255, 0.11);
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    box-sizing: border-box;
    padding: 0 25px;
    .RowTop {
      display: flex;
      justify-content: space-between;
      .RowTopName {
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 22px;
      }
      .time {
        font-size: 14px;
        font-weight: 500;
        color: #666666;
        line-height: 20px;
      }
      .classInfo {
        width: 300px;
        text-align: left;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        span:nth-child(2) {
          margin: 0 47px;
        }
      }
    }
    .rowName {
      font-size: 18px;
      font-weight: 500;
      color: #000;
      line-height: 22px;
    }

    .rowBottom {
      display: flex;
      justify-content: space-between;
      .status {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: auto;
        }
        span {
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
          margin-left: 8px;
        }
      }
      .buttonList {
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        .btn {
          display: flex;
          align-items: center;
          margin: 0 12px;
          img {
            width: 14px;
            height: auto;
          }
          span {
            font-size: 14px;
            font-weight: 500;
            line-height: 20px;
            padding-left: 5px;
          }
        }
      }
    }
  }
}
.pagination {
  margin: 0 auto;
  margin-top: 30px;
}
.btnBox {
  padding: 10px 0;
  display: flex;
  align-content: center;
  justify-content: space-between;
}
</style>